<template>
  <div class="flex flex-col gap-2 text-left" data-testid="document-history">
    <p class="text-sm font-semibold text-textPrimary">Histórico</p>
    <p v-if="!events.length" class="text-xs text-[#7f7f8e]">Sem eventos ainda.</p>
    <ol v-else class="flex flex-col gap-2 border-l-2 border-[#e8e8ed] pl-3 ml-1">
      <li
        v-for="(event, index) in sorted"
        :key="`${event.kind}-${event.at}-${index}`"
        class="relative"
        data-testid="document-history-event"
      >
        <span
          class="absolute -left-[19px] top-1 w-2.5 h-2.5 rounded-full"
          :class="DOT[event.kind]"
          aria-hidden="true"
        />
        <p class="text-[12px] font-semibold text-textPrimary">
          {{ HISTORY_KIND_LABEL[event.kind] }}
          <template v-if="event.versionNumber">· versão {{ event.versionNumber }}</template>
        </p>
        <p class="text-[11px] text-[#52526f]">
          {{ formatDateTime(event.at) }}
          <template v-if="historyAuthorText(event)">· {{ historyAuthorText(event) }}</template>
        </p>
        <p v-if="event.detail" class="text-[11px] text-[#7f7f8e]">{{ event.detail }}</p>
      </li>
    </ol>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type {
  DocumentHistoryEvent,
  DocumentHistoryKind
} from '@/types/professional-documents.types'

import { HISTORY_KIND_LABEL, formatDateTime, historyAuthorText } from './labels'

const props = defineProps<{ events: DocumentHistoryEvent[] }>()

/** O backend já manda do mais novo para o mais antigo; reordenar só protege a leitura. */
const sorted = computed(() => [...props.events].sort((a, b) => Date.parse(b.at) - Date.parse(a.at)))

const DOT: Record<DocumentHistoryKind, string> = {
  SUBMITTED: 'bg-primary30',
  APPROVED: 'bg-sucess',
  REJECTED: 'bg-negative',
  EXPIRED: 'bg-alert',
  UNDONE: 'bg-gray-400'
}
</script>
